// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"u-flowable-image-select_edit_checkbox_V2a-FNu1","image":"u-flowable-image-select_edit_image_V2a-FNu1","desc":"u-flowable-image-select_edit_desc_V2a-FNu1"};